import React from 'react'

export const SectionF = () => {
  return (
    <>
    <section className="section-6">
            <div className="container">
                <form className="form">
                    <div className="descr">Contact us</div>
                    <div className="input">
                        <input required="" autoComplete="off" type="text"/>
                        <label htmlFor="name">Name</label>
                    </div>

                    <div className="input">
                        <input required="" autoComplete="off" name="email" type="text"/>
                        <label htmlFor="email">E-mail</label>
                    </div>

                    <div className="input">
                        <textarea required="" cols="30" rows="1" id="message"></textarea>
                        <label htmlFor="message">Message</label>
                    </div>
                    <button id="formbt">Send message →</button>
                </form>
            </div>
        </section>
    </>
  )
}
